import React from "react";
import { Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  useMediaQuery,
  useTheme,
  Box,
} from "@mui/material";
import { styled } from "@mui/system";

const InstagramLink = styled("a")({
  textDecoration: "none",
  color: "pink",
  "&:hover": {
    color: "cyan",
  },
});

const FooterLink = styled(Link)({
  textDecoration: "none",
  color: "inherit",
  marginLeft: "15px",
  "&:hover": {
    color: "white",
  },
});

const OrderNumber = styled(Typography)(({ theme }) => ({
  marginLeft: "auto", // This pushes the component to the right in flex container for desktop
  marginTop: theme.spacing(1), // This adds some space above for mobile
}));

const Footer = ({ guestNumber }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <AppBar
      sx={{ backgroundColor: "#541b14" }}
      position="static"
      color="primary"
    >
      <Container maxWidth="md">
        <Toolbar
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
            flexDirection: isMobile ? "column" : "row",
          }}
        >
          <Typography
            variant="body1"
            color="inherit"
            style={{ margin: isMobile ? "7px 0 3px 0" : "0" }}
          >
            © {new Date().getFullYear()} malayalam.ai{" "}
            {isMobile && (
              <InstagramLink
                href="https://www.instagram.com/mallutrump"
                target="_blank"
                rel="noopener noreferrer"
              >
                @mallutrump
              </InstagramLink>
            )}
          </Typography>
          {!isMobile && (
            <>
              <span>&nbsp;//&nbsp;</span>
              <Typography variant="body1" color="inherit">
                <InstagramLink
                  href="https://www.instagram.com/mallutrump"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @mallutrump
                </InstagramLink>
              </Typography>
            </>
          )}
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            marginBottom={isMobile ? "10px" : ""}
          >
            <FooterLink to="/terms">Terms of Service</FooterLink>
            <FooterLink to="/privacy">Privacy</FooterLink>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Footer;
